<template lang="pug">
modal#warning-discard-and-close-envelope-modal(
  :no-footer='true'
  :title='$t("modal.warningDiscardAndCloseModal.title")'
  ref='modal'
  size='sm'
)
  .text-start(v-html='$t("modal.warningDiscardAndCloseModal.message")')
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/warning-envelope.svg')
  .text-end.mt-5
    button.btn.btn-secondary.me-2(
      @click='close'
      data-bs-dismiss='modal'
      type='button'
    )
      span.text {{ $t('modal.warningDiscardAndCloseModal.closeButton') }}
    button.btn.btn-danger(
      @click='discardChanges'
      data-bs-dismiss='modal'
      type='button'
    )
      span.text {{ $t('modal.warningSaveAndCloseEnvelope.discardButton') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'WarningSaveAndCloseEnvelopeModal',
  components: {
    Modal,
  },
  methods: {
    close() {
      this.$emit('close');
    },
    discardChanges() {
      this.$emit('discardChanges');
    },
  },
};
</script>
